import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export const LOANS_ROUTING_PARAMS = {
  loanId: 'loanId',
  applicationId: 'applicationId',
  tab: 'tab',
  subtab: 'subtab',
  entityId: 'entityId',
  section: 'section',
  subsection: 'subsection',
};

export class LoansPaths {
  static loans = new EnhancedPath('/loans');
  static applications = new EnhancedPath('/applications');

  static loanApplicationManagement = new EnhancedPath(
    `${LoansPaths.loans.path}/:${LOANS_ROUTING_PARAMS.loanId}/management/:${LOANS_ROUTING_PARAMS.tab}?/:${LOANS_ROUTING_PARAMS.subtab}?`,
  );

  static applicationManagement = new EnhancedPath(
    `${LoansPaths.applications.path}/:${LOANS_ROUTING_PARAMS.applicationId}/management/:${LOANS_ROUTING_PARAMS.tab}?/:${LOANS_ROUTING_PARAMS.subtab}?/:${LOANS_ROUTING_PARAMS.entityId}?/:${LOANS_ROUTING_PARAMS.section}?/:${LOANS_ROUTING_PARAMS.subsection}?`,
  );
}

const routesConfig = {
  settings: {
    layout: {
      config: {
        sidebar: {
          isResponsive: true,
          isOpen: false,
        },
      },
    },
  },
  routes: [
    {
      path: LoansPaths.loanApplicationManagement.path,
      component: lazyWithRetry(() => import('app/pages/loanApplication')),
      pageCode: PAGE_CODES.LOAN_APPLICATION,
    },
    {
      path: LoansPaths.applicationManagement.path,
      component: lazyWithRetry(() => import('app/pages/loanApplication')),
      pageCode: PAGE_CODES.LOAN_APPLICATION,
    },
  ],
};

export default routesConfig;
